import { UNIT_TYPE_OPTIONS } from "../../Inventory/Unit/shared/constants/unitTypes";
import { PAYMENT_TYPE_LABELS, PAYMENT_TYPE_OPTIONS } from "../../../common/paymentTypes";

// Contract.type choices on the backend (clients/models/contract.py).
export const CONTRACT_TYPES = [
  { value: "PRE-CONTRACT", label: "Pre-contract" },
  { value: "CASH", label: "Cash" },
  { value: "CREDIT", label: "Credit" },
  { value: "DEVELOPER", label: "Developer" },
  { value: "OTHER", label: "Other" },
];

// The extractor reports PROMISE / SALE / OTHER (clients/pdf_extractor.py),
// which aren't Contract.type values. A promise is a pre-contract; a sale can
// be cash or credit, which the document doesn't say — left for the user.
export const EXTRACTED_TYPE_MAP = {
  PROMISE: "PRE-CONTRACT",
  SALE: "",
  OTHER: "OTHER",
};

// Payment types a row can be set to: Payment.type's choices (mirrored in
// common/paymentTypes.js), minus BALANCE — the balance is the generated
// last row that takes the remainder, so a second one can't be added by hand.
export const EDITABLE_PAYMENT_TYPES = PAYMENT_TYPE_OPTIONS.filter((o) => o.value !== "BALANCE");
export { PAYMENT_TYPE_LABELS };

export const UNIT_TYPES = UNIT_TYPE_OPTIONS;
export const UNIT_TYPE_LABEL = UNIT_TYPE_OPTIONS.reduce((acc, t) => ({ ...acc, [t.value]: t.label }), {});

export const SEVERITY_COLORS = {
  High: ["#fbe7e6", "#a4302e"],
  Medium: ["#fdf1dc", "#8a5a0c"],
  Low: ["#eef0f4", "#4a4a57"],
};

export const SEVERITY_ORDER = { High: 0, Medium: 1, Low: 2 };

// Names of the backend's extraction sections (contract_extraction_v2/text.py
// SECTIONS), as reported in `sections_missing`.
export const SECTION_LABELS = {
  1: "1.x — the parties",
  2: "2.x — the property",
  3: "3.x — price and payments",
  authentication: "the notary's closing (Încheiere de autentificare)",
};

export const STEP_TITLES = ["Import document", "Contract details", "Units", "Payments"];
